import { Instance, types } from 'mobx-state-tree';

export interface IBranch extends Instance<typeof Branch> {}

export const Branch = types.model('Branch', {
    branchName: types.string,
    manifestUrl: types.string,
    executablePath: types.maybeNull(types.string),
    useBranchDirectory: types.optional(types.boolean, false),
    parameter: types.maybeNull(types.array(types.string)),
    serviceId: types.optional(types.string, '', [null, undefined]),
    toyServiceId: types.optional(types.string, '', [null, undefined]),
});
